/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretCircleDoubleDown(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M54.46094,54.46094a103.95314,103.95314,0,1,0,147.07812,0A104.12262,104.12262,0,0,0,54.46094,54.46094Zm99.88281,83.88281a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,164.6875Zm0-56a7.99915,7.99915,0,1,1,11.3125,11.3125l-32,32a7.99708,7.99708,0,0,1-11.3125,0l-32-32a7.99915,7.99915,0,0,1,11.3125-11.3125L128,108.6875Z" />
    </Svg>
  );
}

export default CaretCircleDoubleDown;
